import formatName from 'I18n/utils/formatName';
import FormattedName from 'I18n/components/FormattedName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Avatar } from 'avatar-components';
import { getContactLink } from '../../../url/getContactLink';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactInSystemSection = ({
  firstName,
  lastName,
  vid,
  email
}) => {
  const displayName = firstName === undefined && lastName === undefined ? email : formatName({
    firstName,
    lastName
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    marginBlockStart: "250",
    children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-inbox-message-history.contact-promotion-modal.emailFound.stepTwoLabel',
      options: {
        emailAddress: email
      }
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: "250",
      marginBlockStart: "250",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Avatar, {
        email: email,
        vid: vid,
        displayName: displayName
      }), /*#__PURE__*/_jsx(Link, {
        external: true,
        href: getContactLink(vid),
        children: /*#__PURE__*/_jsx(FormattedName, {
          email: email,
          givenName: firstName,
          familyName: lastName
        })
      })]
    })]
  });
};
ContactInSystemSection.displayName = 'ContactInSystemSection';
export default ContactInSystemSection;